import React from "react";
import { ReactComponent as Warning } from "../../../../assets/icons/Warning.svg";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";

export const VerificationBanner = ({ getUrl, status }) => {
  return (
    <div className="bg-warning border-warning border rounded-lg p-3 mb-5 text-left text-warning flex gap-3 items-center text-f16">
      {status === "IN_PROGRESS" ? <Spinner /> : <Warning />}
      <span>
        Your company verification is {status === "PENDING" ? "still pending" : status === "FAILED" ? "failed" : "in progress"}.{" "}
        {status !== "IN_PROGRESS" ? (
          <>
            Click{" "}
            <span onClick={getUrl} className="text-primaryText font-semibold cursor-pointer">
              here
            </span>
            {status === "PENDING" ? " to verify now." : " to restart the Verification"}
          </>
        ) : (
          " Sit back and relax."
        )}
      </span>
    </div>

  );
};
